import axios from 'axios';

const instance = axios.create({ baseURL: process.env.REACT_APP_URL_BASE });

const request = {
    post: (url, body, token) => instance.post(url, body, { headers: { 'Authorization': 'Bearer ' + token, "content-type": "multipart/form-data" } } ),
}

export default request;